import {Settings} from './settings';

export interface CoreSettings extends Settings {
  translationLanguage: Language;
  mandant: EnvironmentMandant;
  api: ApiSettings;
  config: CoreConfigSettings;
  app_root_url: string;
}

export interface KeycloakConfig {
  realm: string;
  url: string;
  clientId: string;
}

export interface ApiSettings {
  middlewareUrl: string;
  googleTagManagerId: string;
  googleUAId: string;
}

export interface CoreConfigSettings {
  environmentName: string;
  environmentMode: string;
  useGoogleTagManager: boolean;
  showEnvironmentInfo?: boolean;
  askForLeavingPage?: boolean;
}


export enum Language {
  DE = 'de',
  AT = 'at'
}

export enum EnvironmentMandant {
  LV = 'LV'
}

